/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Action_ReadInputs */

const cs_gdpr_action_read = /** @type {(inputs: Gdpr_Action_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevření`)
};

const en_gdpr_action_read = /** @type {(inputs: Gdpr_Action_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opened`)
};

/**
* | output |
* | --- |
* | "Opened" |
*
* @param {Gdpr_Action_ReadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_action_read = /** @type {((inputs?: Gdpr_Action_ReadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Action_ReadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_action_read(inputs)
	return cs_gdpr_action_read(inputs)
});